import * as classNames from "classnames";
import * as React from "react";

import { Classes, IMPDSelectableItem } from "src/mpd-library";

import { Checkbox, ICheckboxProps, Text } from "@blueprintjs/core";

import "./styles.css";

export interface IGroupsListItemProps extends IMPDSelectableItem, ICheckboxProps {
  checked?: boolean;
  title?: string;
  description?: string;
  members?: Array<any>;
  type?: string;
  loading?: boolean;
}

export class GroupsListItem extends React.Component<IGroupsListItemProps> {
  public render() {
    const { checked, title, description, members, type, className, loading, onItemClick, ...checkBoxProps } = this.props;
    const classes = classNames('groups-list-item-container', loading && Classes.LOADING, className);
    return (
      <div className={classes} onClick={onItemClick}>
        <Checkbox
            className={classNames(checked && Classes.ACTIVE)}
            checked={checked}
            label={title}
            {...checkBoxProps}
        />
        <Text className='group-list-item-description'> { description } </Text>
        <Text className={classNames('group-list-item-type', type)}> {type} </Text>
        <Text className='group-list-item-members'> { members && members.length } Members </Text>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/list-items/groups-list-item/groups-list-item.tsx